/**
 * Created by Victor Rybakov
 * date 2016-05-10
 * DataModelPermissions
 */

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { DataModelPermissionsWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-data-permissions.sass');

export class DataModelPermissionsWidget extends WidgetBase {
    public static _name: string = 'Data Permissions';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-data-permissions';
    public static icon: string = 'lock';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-data-permissions'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(DataModelPermissionsWidget);
